import React, {useState} from "react";

export const BreadcrumbsContext = React.createContext({
    elementiBreadcrumbs: [],
    clearElementiBreadcrumbs: () => {
    },
    initElementiBreadcrumbs: () => {
    },
    addElementoBreadcrumbs: () => {
    },
    backElementiBreadcrumbs: () => {
    },
    goToElementoBreadcrumbs: () => {
    },
});

export const BreadcrumbsProvider = ({children}) => {

    const [elementiBreadcrumbs, setElementiBreadcrumbs] = useState([]);

    function clearElementiBreadcrumbs() {
        setElementiBreadcrumbs([]);
    }

    function initElementiBreadcrumbs(name, label, href) {
        setElementiBreadcrumbs([{name, label, href}]);
    }

    function addElementoBreadcrumbs(name, label, href, after) {
        const nuovoElemento = {name, label, href};

        if (after) {
            const index = elementiBreadcrumbs.findIndex(el => el.name === after);
            if (index !== -1) {
                setElementiBreadcrumbs([...elementiBreadcrumbs.slice(0, index + 1), nuovoElemento]);
            } else {
                setElementiBreadcrumbs([...elementiBreadcrumbs, nuovoElemento]);
            }
        } else {
            setElementiBreadcrumbs([...elementiBreadcrumbs, nuovoElemento]);
        }
    }

    function backElementiBreadcrumbs() {
        setElementiBreadcrumbs(elementiBreadcrumbs.slice(0, -1));
    }

    function goToElementoBreadcrumbs(name) {
        const index = elementiBreadcrumbs.findIndex(el => el.name === name);
        if (index !== -1) {
            setElementiBreadcrumbs(elementiBreadcrumbs.slice(0, index + 1));
        }
    }

    return (
        <BreadcrumbsContext.Provider
            value={{
                elementiBreadcrumbs,
                clearElementiBreadcrumbs,
                initElementiBreadcrumbs,
                addElementoBreadcrumbs,
                backElementiBreadcrumbs,
                goToElementoBreadcrumbs,
            }}>{children}</BreadcrumbsContext.Provider>
    );
};
